function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

export { getNodeName as g };
//# sourceMappingURL=getNodeName-2bd07335.js.map
